import Persona from 'persona';
import { useIoContext, useStoreActions } from "../contexts";
import { useStateInRef } from 'seagull';
export function personaClient(onError, _onReady, onComplete) {
  return {
    open(inquiryId, sessionToken) {
      const client = new Persona.Client({
        inquiryId: inquiryId,
        sessionToken: sessionToken || undefined,
        onError,
        onReady: () => {
          _onReady === null || _onReady === void 0 ? void 0 : _onReady();
          client.open();
        },
        onComplete
      });
    }

  };
}
export function usePersona(props) {
  const getProps = useStateInRef(props);
  const {
    personaClient
  } = useIoContext();
  const {
    api
  } = useStoreActions();
  return {
    async open(businessId) {
      const {
        onError,
        onReady,
        onComplete
      } = getProps();
      const client = personaClient(onError, onReady, onComplete);

      if (businessId != null) {
        try {
          const {
            inquiryId,
            sessionToken
          } = await api.vendor.getKYBInquiry(businessId);
          client.open(inquiryId, sessionToken);
        } catch (exn) {
          console.log(exn);
          onError(exn);
        }
      }
    }

  };
}